import { createSlice } from '@reduxjs/toolkit';
import { fetchActionItems } from './actionItemsThunk';

interface ActionItem {
  id: number;
  title: string;
  description: string;
  status: string;
}

interface ActionItemState {
  data: ActionItem[];
  loading: boolean;
  error: string | null;
}

const initialState: ActionItemState = {
  data: [],
  loading: false,
  error: null,
};

const actionItemSlice = createSlice({
  name: 'actionItems',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActionItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActionItems.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchActionItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default actionItemSlice.reducer;
